module.exports = __webpack_public_path__ + "static/media/bullets.cd1ead1c.svg";